import authService from "../app/services/auth/AuthService";
import {UserTypeEnum, userTypesWithLang} from "../app/model/user/UserModel";
import useTranslation from "../hooks/useTranslation";

const userType = authService.getUserType();
const getAppNameByUserType = (type: UserTypeEnum): string => {
    switch (type) {
        case UserTypeEnum.Admin:
            return 'Zuppin';
        case UserTypeEnum.Firm:
            return 'Firma';
        case UserTypeEnum.Passenger:
            return 'Yolcu';
        case UserTypeEnum.CountryAdmin:
            const stored = localStorage.getItem("selectedServiceCountry");
            return stored ? JSON.parse(stored).countryName : undefined;
        case UserTypeEnum.AirportGreeter:
            return 'Karşılama';
        default:
            return userTypesWithLang[7].name;
    }
};
const themeConfig = {
    app: {
        appName: getAppNameByUserType(userType as UserTypeEnum),
        appLogoImage: require('../assets/images/logo/zuppin-logo.png')
    },
    layout: {
        isRTL: false,
        skin: 'light',
        routerTransition: 'fadeIn',
        type: 'vertical',
        contentWidth: 'full',
        menu: {
            isHidden: false,
            isCollapsed: false
        },
        navbar: {
            type: 'floating',
            backgroundColor: 'black'
        },
        footer: {
            type: 'static'
        },
        customizer: false,
        scrollTop: true
    }
}

export default themeConfig
